// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"Managers_contentSection__yGJ4F","content":"Managers_content__1XNEF","title":"Managers_title__2k8M_","pagination":"Managers_pagination__2G9Xi"};